import { BaseService } from "./BaseService";
import {
  CommunicationFeedbackSettings,
  RequestFeedbackSettings,
  UpdateCommunicationFeedbackSettingsPayload,
} from "@/types/feedback-settings";

class FeedbackSettingsService extends BaseService {
  async getRequestFeedbackSettings(): Promise<RequestFeedbackSettings> {
    return this.get<RequestFeedbackSettings>("/feedback-settings/requests");
  }

  async updateRequestFeedbackSettings(
    data: RequestFeedbackSettings,
  ): Promise<RequestFeedbackSettings> {
    return this.put<RequestFeedbackSettings>(
      "/feedback-settings/requests",
      data,
    );
  }

  async getCommunicationFeedbackSettings(): Promise<CommunicationFeedbackSettings> {
    return this.get<CommunicationFeedbackSettings>(
      "/feedback-settings/communication",
    );
  }

  async updateCommunicationFeedbackSettings(
    data: UpdateCommunicationFeedbackSettingsPayload,
  ): Promise<CommunicationFeedbackSettings> {
    return this.put<CommunicationFeedbackSettings>(
      "/feedback-settings/communication",
      data,
    );
  }
}

export const feedbackSettingsService = new FeedbackSettingsService();
